import { Inject } from '@angular/core';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { TermsService } from '@go-modules/services/terms/terms.service';
import { openManagedMatDialog } from '@go-modules/utilities';
import { UniqueIdGeneratorUtil } from '@go-modules/utilities/unique-id-generator/unique-id-generator.util';

export interface TermsOfUseDialogData {
	dialogTitleId?: string;
}

@Component({
	selector: 'terms-of-use-dialog',
	templateUrl: './terms-of-use-dialog.component.html',
	styleUrls: ['./terms-of-use-dialog.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class TermsOfUseDialogComponent implements OnInit {

	public form: UntypedFormGroup;

	public static open (
		dialog: MatDialog,
		config?: MatDialogConfig<TermsOfUseDialogData>
	): MatDialogRef<TermsOfUseDialogComponent, boolean> {
		const dialogTitleId = config?.data?.dialogTitleId ?? TermsOfUseDialogComponent.getDialogTitleId();

		return openManagedMatDialog(dialog, TermsOfUseDialogComponent, {
			...(config ?? {}),
			data: {
				...(config?.data ?? {}),
				dialogTitleId
			},
			ariaLabelledBy: dialogTitleId
		});
	}

	private static getDialogTitleId (): string {
		return `terms-of-use-dialog-title-${UniqueIdGeneratorUtil.getId()}`;
	}

	constructor (
		@Inject(MAT_DIALOG_DATA) public data: TermsOfUseDialogData,
		private dialogRef: MatDialogRef<TermsOfUseDialogComponent>,
		private termsService: TermsService
	) {
		this.dialogRef.disableClose = true;
		this.data.dialogTitleId ??= TermsOfUseDialogComponent.getDialogTitleId();
	}

	public ngOnInit () {
		this.form = new UntypedFormGroup({
			acceptTerms: new UntypedFormControl(false, [Validators.requiredTrue])
		});
	}

	public accept () {
		if (this.form.valid) {
			this.termsService.accept();
			this.dialogRef.close();
		}
	}
}
